import React from 'react';

const FilterVector = (): JSX.Element => (
  <svg
    strokeWidth="100"
    width="30"
    height="20"
    viewBox="0 0 30 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeWidth="100"
      d="M11.6667 20H18.3333V16.6667H11.6667V20ZM0 0V3.33333H30V0H0ZM5 11.6667H25V8.33333H5V11.6667Z"
      fill="#222222"
    />
  </svg>
);

export default FilterVector;
